@if (last() === false) {
  <mat-list-item>
    <div class="audit-top-line"></div>
    <div class="audit-bottom-line"></div>
    <mat-icon matListItemIcon>{{icon()}}</mat-icon>
    <h4 mat-line>{{authorLabel()}}</h4>
    <p mat-line class="audit-text" [innerHTML]="text()"></p>
    <p mat-line class="audit-date">{{(date() | date:'medium') || ('No date' | translate)}}</p>
  </mat-list-item>
}

@if (last() !== false) {
  <mat-list-item>
    <div class="audit-top-line"></div>
    <mat-icon matListItemIcon>trip_origin</mat-icon>
    <h4 mat-line>{{authorLabel()}}</h4>
    <p mat-line class="audit-text" [innerHTML]="text()"></p>
    <p mat-line>{{(date() | date:'medium') || ('No date' | translate)}}</p>
  </mat-list-item>
}
